import axios from "./axios-decorator";

const baseAxiosUrl = window.location.origin;

/**
* Get bookings.
*/
export const getBookings = async (): Promise<any> => {
    let url = `${baseAxiosUrl}/api/bookings`;
    return await axios.get(url);
}

/**
* Get bookings by id.
*/
export const getBookingsById = async (bookingsId: string): Promise<any> => {
    let url = `${baseAxiosUrl}/api/bookings/${bookingsId}`;
    return await axios.get(url);
}

/**
* Get bookings services.
*/
export const getServices = async (bookingsId: string): Promise<any> => {
    let url = `${baseAxiosUrl}/api/bookings/services?bookingsId=${bookingsId}`;
    return await axios.get(url);
}

/**
* Get bookings services.
*/
export const getServicesExternal = async (bookingsId: string): Promise<any> => {
    let url = `${baseAxiosUrl}/api/bookings/servicesAll?bookingsId=${bookingsId}`;
    return await axios.get(url);
}

/**
* Get bookings staff members.
*/
export const getStaffMembers = async (bookingsId: string): Promise<any> => {
    let url = `${baseAxiosUrl}/api/bookings/staffmembers?bookingsId=${bookingsId}`;
    return await axios.get(url);
}

/**
* Get bookings staff members.
*/
export const updateStaffMember = async (request: any): Promise<any> => {
    let url = `${baseAxiosUrl}/api/bookings/updateStaffMember`;
    return await axios.post(url, request);
}

/**
* Get staff availability.
*/
export const postStaffAvailability = async (request: any): Promise<any> => {
    let url = `${baseAxiosUrl}/api/bookings/staffAvailability`;
    return await axios.post(url, request);
}

/**
* Post appointment with.
*/
export const postAppointment = async (request: any): Promise<any> => {
    let url = `${baseAxiosUrl}/api/bookings/appointments`;
    return await axios.post(url, request);
}

/**
* Get user name.
*/
export const getUserName = async (): Promise<any> => {
    let url = `${baseAxiosUrl}/api/bookings/userName`;
    return await axios.get(url);
}